(function () {
  'use strict';

  const SELECTOR = '[data-sf-hero-rotator]';

  function initRotator(root) {
    root.dataset.sfHeroTapLayerFix = '1';
    const slides = Array.prototype.slice.call(root.querySelectorAll('.sf-hero-rotator__slide'));
    if (slides.length <= 1) return;

    const prev = root.querySelector('[data-sf-hero-prev]');
    const next = root.querySelector('[data-sf-hero-next]');
    const counter = root.querySelector('[data-sf-hero-current]');

    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const auto = root.dataset.autoRotate === 'true' && !isMobile;
    const interval = parseInt(root.dataset.rotateMs, 10) || 6000;
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let current = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    if (current < 0) current = 0;

    let timer = null;
    const dots = buildDots(root, slides.length, show, start);

    function show(index) {
      const n = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        const active = i === n;
        const focusable = slide.querySelectorAll('a, button, input, select, textarea, [tabindex]');
        slide.classList.toggle('is-active', active);
        if (active) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
        focusable.forEach(function (element) {
          if (!element.dataset.sfHeroOriginalTabindex && element.hasAttribute('tabindex')) {
            element.dataset.sfHeroOriginalTabindex = element.getAttribute('tabindex');
          }
          if (active) {
            if (element.dataset.sfHeroOriginalTabindex) {
              element.setAttribute('tabindex', element.dataset.sfHeroOriginalTabindex);
            } else {
              element.removeAttribute('tabindex');
            }
          } else {
            element.setAttribute('tabindex', '-1');
          }
        });
      });
      current = n;
      if (counter) counter.textContent = String(n + 1);
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === n);
      });
    }

    function start() {
      if (!auto || reduceMotion) return;
      stop();
      timer = window.setInterval(function () { show(current + 1); }, interval);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    if (prev) prev.addEventListener('click', function () { show(current - 1); start(); });
    if (next) next.addEventListener('click', function () { show(current + 1); start(); });

    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;
    let suppressClickUntil = 0;
    root.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });

    root.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;
      if (handleSwipe()) suppressClickUntil = Date.now() + 450;
    }, { passive: true });

    function handleSwipe() {
      const thresholdX = 50;
      const diffX = touchEndX - touchStartX;
      const diffY = touchEndY - touchStartY;

      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > thresholdX) {
        show(diffX < 0 ? current + 1 : current - 1);
        start();
        return true;
      }

      return false;
    }

    root.addEventListener('click', function (e) {
      if (Date.now() <= suppressClickUntil) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) start();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    show(current);
    start();
  }

  function buildDots(root, count, showSlide, startTimer) {
    const wrap = document.createElement('div');
    wrap.className = 'sf-hero-rotator__dots';
    wrap.setAttribute('aria-label', 'Slideshow pagination');
    const dots = [];
    for (let i = 0; i < count; i++) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'sf-hero-rotator__dot';
      dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        showSlide(i);
        startTimer();
      });
      wrap.appendChild(dot);
      dots.push(dot);
    }
    root.appendChild(wrap);
    return dots;
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initRotator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const target = event.target.querySelector(SELECTOR);
    if (target) initRotator(target);
  });
})();
